import { FC, useState } from 'react';
import ActionGroupItemLabel from 'components/Shared/ActionsButtonDetailsPage/ActionGroupItemLabel';
import { EIconNames } from 'components/Base/Icon';
import { TEventDetailsDataUI } from 'data/types/events.types';
import AddRegistrationModal from './AddRegistrationModal/AddRegistrationModal';

type Props = { id: string; event: TEventDetailsDataUI };

const AddRegistrationAction: FC<Props> = ({ id, event }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ActionGroupItemLabel
        label="Add Registration"
        icon={EIconNames.PLUS}
        onClick={() => setOpen(true)}
      />
      {open && (
        <AddRegistrationModal
          open={open}
          setOpen={setOpen}
          eventId={id}
          event={event}
        />
      )}
    </>
  );
};

export default AddRegistrationAction;
